import { request } from './request';

// 环境图片项
export interface EnvironmentItem {
  id: number;
  url: string;
  key: string;
}

// 图书类型项
export interface BookTypeItem {
  id: number;
  name: string;
  url: string;
  key: string;
}

// 证件图片项
export interface DocumentPhotoItem {
  id: number;
  url: string;
  key: string;
}

// 开放时间和联系方式项
export interface OpenTimeAndTelItem {
  key: string;
  value: string;
}

// 省图书驿站信息接口响应类型
export interface ProvincialBookStationInfo {
  environment: EnvironmentItem[];
  bookTypeList: BookTypeItem[];
  documentPhotoList: DocumentPhotoItem[];
  openTimeAndTel: OpenTimeAndTelItem[];
}

// 通用响应类型
export interface ApiResponse<T = any> {
  code: number;
  data: T;
  msg: string;
  total?: number;
}

/**
 * 获取省图书驿站信息
 */
export const getProvincialBookStationInfo = () => {
  return request.get('/provincial_book_station/info');
};
